<template>
  <div>
    <a :href="link"
       class="link-text">
      <span style="font-weight: bold; text-transform: uppercase;">{{ labelData.categoryName }}</span>
      <template v-if="labelData.parent">
        <br/>
        ({{ this.t(`reports.${labelData.parent}`) }})
      </template>
    </a>
  </div>
</template>

<script>
import i18n from "@/i18n.js";

export default {
  name: "InputMapLabel",
  props: ['pointData', 'chart', 'tenant', 'labelData'],
  methods: {
    t(value) {
      return i18n.t(value);
    },
  },
  computed: {
    link() {
      if (this.labelData.engineName === 'leadership') {
        return `/#/t/${this.tenant}/reports/rg/${this.labelData.engineName}`;
      }
      return `/#/t/${this.tenant}/reports/rg/${this.labelData.parent}/${this.labelData.engineName}`;
    }
  }
}
</script>

<style>
.link-text {
  display: inline-block;
  text-align: center;
  text-decoration: none !important;
  color: #000 !important;
}

@media screen and (max-width: 500px) {
  .link-text {
    font-size: 9px;
  }
}
</style>
